import React, { FC } from 'react';
import { IconProps } from '../types';
import { iconDefaultProps } from '../const';
import IconStyled from '../icon.styled';

const IconAngleDown: FC<IconProps> = ({ $size, ...rest }) => (
  <IconStyled {...{ $size, ...rest }}>
    <svg width={$size} height={$size} viewBox="0 0 10 8" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path d="M9.64277 0H0.357161C0.159919 -1.14441e-05 1.11613e-05 0.137736 7.55664e-10 0.307669C-3.86326e-06 0.35885 0.0148111 0.409222 0.0431031 0.454226L4.68591 7.83875C4.77982 7.98819 4.99656 8.04374 5.17001 7.96283C5.23098 7.93439 5.28102 7.89128 5.31402 7.83875L9.95683 0.454226C10.0508 0.304803 9.98632 0.118066 9.81288 0.0371346C9.76064 0.0127597 9.70217 -3.8147e-06 9.64277 0Z" />
    </svg>
  </IconStyled>
);

IconAngleDown.defaultProps = iconDefaultProps;
IconAngleDown.displayName = 'IconAngleDown';

export default IconAngleDown;
